import Index from "@/views/platforms_portal/invoices/index";

import {commonBeforeEnter, ifAuthenticated, ifNotAuthenticated} from "../../helper"

const URL_PREFIX='platforms_portal/invoices';
const CODE='platforms_portal.invoices';
const TRANS_CODE='platforms.invoices';
const PERMISSION_PREFIX='partner_invoice';
const routes = [
  {
    path: `${URL_PREFIX}`,
    name:`${CODE}.index`,
    component: Index,
    meta: {
      'can': [`${PERMISSION_PREFIX}_can_view`],
      'removeClass' : [`bg-default`],
      'title': `${TRANS_CODE}.list_title`,
      'breadDetails': {
        'title': `${TRANS_CODE}.title`,
        'index_route': `${CODE}.index`,
        'show': true,
        'items': [
          {
            'title': `crud.list`,
          }
        ]
      }
    },
    beforeEnter: function (to,from, next){
      if(ifAuthenticated(to, from, next)){
        commonBeforeEnter(to, from, next);
      }
    },
  },
];

export default routes;
